<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Hold" class="d-icon d-icon--hold" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 2.375c0-.483.392-.875.875-.875h.25c.483 0 .875.392.875.875v7.25a.875.875 0 0 1-.875.875h-.25a.875.875 0 0 1-.875-.875v-7.25Zm5 0c0-.483.392-.875.875-.875h.25c.483 0 .875.392.875.875v7.25a.875.875 0 0 1-.875.875h-.25a.875.875 0 0 1-.875-.875v-7.25Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHold',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
